export default __webpack_public_path__ + "static/media/scrabble-1024w.fa8ccbc9.png";